import React from 'react'
import  { airlineService } from '../jwt/_services/hotel/airlineService'

export const airlineProvider = {
    getOptions
}

async function getOptions() {
    try {
        const listItems = await airlineService.getOptions();

        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code,
                    label: <label>{ item.title }</label>
                }
            )
        });
    } catch (error) {
        console.log(error)
    }
}